import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import { App } from "@/app/App";
import { ErrorBoundary } from "@/app/ErrorBoundary";
import { BrandingProvider } from "@/app/branding";
import { ToastProvider } from "@/app/toast";
import { AuthProvider } from "@/app/auth";

import i18n from "@/i18n";
import { setApiLanguage } from "@/api/client";
import { applyStylesheet } from "@/styles/direction";

setApiLanguage(i18n.language);
applyStylesheet(i18n.dir(i18n.language));
i18n.on("languageChanged", (code) => {
    setApiLanguage(code);
    applyStylesheet(i18n.dir(code));
});

const client = new QueryClient({
    defaultOptions: {
        queries: { retry: false, staleTime: 30_000, refetchOnWindowFocus: false },
    },
});

createRoot(document.getElementById("root") as HTMLElement).render(
    <StrictMode>
        <QueryClientProvider client={client}>
            <BrowserRouter>
                <BrandingProvider>
                    <ToastProvider>
                        <AuthProvider>
                            <ErrorBoundary>
                                <App />
                            </ErrorBoundary>
                        </AuthProvider>
                    </ToastProvider>
                </BrandingProvider>
            </BrowserRouter>
        </QueryClientProvider>
    </StrictMode>,
);
